import { useEffect, useState } from "react";

const Pagination = ({ totPages, setCurrPage, currPage = 1 }) => {
  const pageNums = [];
  for (let i = 1; i <= totPages; i++) {
    pageNums.push(i);
  }

  const [currentButton, setCurrentButton] = useState(currPage);

  // Mantiene sincronizzato il pulsante attivo se il padre resetta la pagina
  useEffect(() => {
    setCurrentButton(currPage);
  }, [currPage]);

  useEffect(() => {
    if (currentButton > totPages && totPages > 0) {
      setCurrentButton(1);
    }
  }, [totPages]);

  const handlePageClick = (page) => {
    setCurrentButton(page);
    setCurrPage(page);
  };

  return (
    <div>
      <nav className="d-flex justify-content-center">
        <ul className="pagination">
          <li className={currentButton === 1 ? "page-item disabled" : "page-item"}>
            <button
              className="page-link"
              onClick={() => handlePageClick(currentButton > 1 ? currentButton - 1 : 1)}
            >
              <i style={{ fontSize: "16px", paddingTop: "1px" }} className="material-icons">
                &#xe5e0;
              </i>
            </button>
          </li>
          {pageNums.map((page, index) => (
            <li key={index} className={currentButton === page ? "page-item active" : "page-item"}>
              <button className="page-link" onClick={() => handlePageClick(page)}>
                {page}
              </button>
            </li>
          ))}
          <li className={currentButton === pageNums.length ? "page-item disabled" : "page-item"}>
            <button
              className="page-link"
              onClick={() =>
                handlePageClick(currentButton < pageNums.length ? currentButton + 1 : pageNums.length)
              }
            >
              <i style={{ fontSize: "16px", paddingTop: "1px" }} className="material-icons">
                &#xe5e1;
              </i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;